/**
 * @generated SignedSource<<32877b91343bdacbb9467eca8c68945c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type EmailListInputContactsQuery$variables = {
  doesNotReportUnder?: string | null;
  excludeAncestryFor?: string | null;
  excludeManagedUsers?: boolean | null;
  first?: number | null;
  search?: string | null;
};
export type EmailListInputContactsQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly emailDomainList: ReadonlyArray<string>;
      readonly isPersonalType: boolean;
    };
    readonly contacts: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly email: string;
          readonly fullName: string;
          readonly groupSize: number | null;
          readonly id: string;
          readonly image: string;
          readonly isGroup: boolean;
          readonly user: {
            readonly email: string;
            readonly firstName: string;
            readonly id: string;
            readonly internalAttributes: {
              readonly oneOnOneWithViewer: {
                readonly archived: boolean | null;
                readonly id: string;
              } | null;
            } | null;
            readonly isActive: boolean;
            readonly isConfigured: boolean;
            readonly isGuest: boolean;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly user: {
      readonly email: string;
      readonly firstName: string;
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
      readonly isGuest: boolean;
    };
  };
};
export type EmailListInputContactsQuery = {
  response: EmailListInputContactsQuery$data;
  variables: EmailListInputContactsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "doesNotReportUnder"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeAncestryFor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeManagedUsers"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v5 = [
  {
    "kind": "Variable",
    "name": "doesNotReportUnder",
    "variableName": "doesNotReportUnder"
  },
  {
    "kind": "Variable",
    "name": "excludeAncestryFor",
    "variableName": "excludeAncestryFor"
  },
  {
    "kind": "Literal",
    "name": "excludeInactive",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "excludeManagedUsers",
    "variableName": "excludeManagedUsers"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Literal",
    "name": "ranked",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGroup",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupSize",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConfigured",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStream",
  "kind": "LinkedField",
  "name": "oneOnOneWithViewer",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archived",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v8/*: any*/),
    (v7/*: any*/),
    (v12/*: any*/),
    (v9/*: any*/),
    (v15/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPersonalType",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailDomainList",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailListInputContactsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "ContactNodeConnection",
            "kind": "LinkedField",
            "name": "contacts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContactNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContactNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v8/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserInternalAttributes",
                            "kind": "LinkedField",
                            "name": "internalAttributes",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EmailListInputContactsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "ContactNodeConnection",
            "kind": "LinkedField",
            "name": "contacts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContactNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContactNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v8/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserInternalAttributes",
                            "kind": "LinkedField",
                            "name": "internalAttributes",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              (v19/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ff21252c1b4fccad4c7ab6b405eb0906",
    "id": null,
    "metadata": {},
    "name": "EmailListInputContactsQuery",
    "operationKind": "query",
    "text": "query EmailListInputContactsQuery(\n  $search: String\n  $first: Int\n  $excludeManagedUsers: Boolean\n  $excludeAncestryFor: ID\n  $doesNotReportUnder: ID\n) {\n  viewer {\n    contacts(first: $first, search: $search, excludeManagedUsers: $excludeManagedUsers, excludeAncestryFor: $excludeAncestryFor, doesNotReportUnder: $doesNotReportUnder, ranked: true, excludeInactive: true) {\n      edges {\n        node {\n          id\n          fullName\n          email\n          image\n          isGroup\n          groupSize\n          user {\n            id\n            email\n            firstName\n            isActive\n            isConfigured\n            isGuest\n            internalAttributes {\n              oneOnOneWithViewer {\n                id\n                archived\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n    user {\n      id\n      email\n      fullName\n      firstName\n      image\n      isGuest\n    }\n    account {\n      isPersonalType\n      emailDomainList\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8bc85e85fb77116a81357b350da67c01";

export default node;
